import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { EsnLogoVariant } from '../../../shared/types/atoms';

/**
 * The EchoSpaces brand: full lockup, the collapsed-menu compact mark, or the mark/wordmark alone.
 * Switching full ↔ compact animates the collapse (wordmark fades, mark glides to size).
 */
@Component({
  selector: 'esn-logo',
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': '"esn-logo--" + variant()',
    '[attr.role]': 'label() ? "img" : null',
    '[attr.aria-label]': 'label()',
    '[attr.aria-hidden]': 'label() ? null : "true"',
  },
})
export class LogoComponent {
  readonly variant = input<EsnLogoVariant>('full');

  /**
   * Accessible name; pass null when the logo sits next to the brand name in text.
   */
  readonly label = input<string | null>('EchoSpaces');
}
